(function() {
  'use strict';

  /**
   * @ngdoc directive
   * @name webAgro1App.directive:autoStep
   * @description auto corrects input[number] step attribute based on amount of decimal places
   * # autoStep
   */
  angular
    .module('webAgro1App')
    .directive('autoStep', AutoStepDirective);

  /**
   * Declaration of AutoStepDirective function
   * @return {Object}
   */
  function AutoStepDirective() {

    // directive definition object
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel) {
        /**
         * Updates step attribute of linked element
         */
        function updateStep() {
          var decimals = decimalPlaces(ngModel.$viewValue);
          var step = '1';
          if (decimals > 0) {
            step = '0.';
            for (; decimals > 0; decimals--) {
              step += (decimals === 1) ? '1' : '0';
            }
          }

          element.prop('step', step);
        }

        /**
        * Returns amount of decimal places in a given number
        * @param  {Mixed}  num number to extract amount of decimal places. Can be string or number
        * @return {Number}     amount of decimal places in num
        */
        function decimalPlaces(num) {
          if (num) {
            var match = num.toString().match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
            if (!match) {
              return 0;
            }
            return Math.max(
              0,
              // number of digits right of decimal point
              (match[1] ? match[1].length : 0) -
              // adjust for scientific notation
              (match[2] ? +match[2] : 0)
            );
          }
          return 0;
        }

        // adds listener on view changing
        ngModel.$viewChangeListeners.push(updateStep);

        // automatic set up on focus, works when directly clicking on spinner arrows as well
        // the reason for this is that ngModel inits with undefined $viewValue
        // thus the step would become 1 and ignore all decimal places when changing for the first time
        element.one('focus', updateStep);
      }
    };

  }

}());
